'use client';
import { Passwordless } from 'amazon-cognito-passwordless-auth';
import { PasswordlessContextProvider } from 'amazon-cognito-passwordless-auth/react';
import { Amplify } from 'aws-amplify';
import { PropsWithChildren } from 'react';
import { SignIn } from '../ui/SignIn';

class CustomHistory {
  // TODO: Implement custom history for next.js initialization support
  pushState() {}
}

Amplify.configure(
  {
    Auth: {
      Cognito: {
        userPoolClientId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_CLIENT_ID!,
        userPoolId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID!,
        loginWith: {
          oauth: {
            domain: process.env.NEXT_PUBLIC_COGNITO_DOMAIN!,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: [
              process.env.NEXT_PUBLIC_REDIRECT_SIGN_IN || 'http://localhost:3002/',
            ],
            redirectSignOut: [
              process.env.NEXT_PUBLIC_REDIRECT_SIGN_OUT || 'http://localhost:3002/',
            ],
            responseType: 'code',
          },
        },
      },
    },
  },
  {
    ssr: true,
  }
);

Passwordless.configure({
  clientId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_CLIENT_ID!,
  cognitoIdpEndpoint: 'us-east-1',
  userPoolId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID!,
  history: new CustomHistory(),
});

interface IProps extends PropsWithChildren {
  unathenticatedPaths?: string[];
}

export const AuthenticatorProvider = ({
  children,
  unathenticatedPaths,
}: IProps) => {
  return (
    <PasswordlessContextProvider enableLocalUserCache={true}>
      <SignIn unathenticatedPaths={unathenticatedPaths}>{children}</SignIn>
    </PasswordlessContextProvider>
  );
};
